let colorMap = {
    coal: "#282827", //Coal
    petroleum: "#7DAAA7", //Petroleum
    naturalGas: "#F9BD15", //Natural Gas
    otherGas: "#F04B31", //Other Gases
    nuclear: "#D385AA", //Nuclear
    hydroPumped: "#3F87A6", //Hydroelectric Pumped Storage
    hydroConventional: "#3F87A6", //Conventional Hydroelectric Power
    wood: "#B15A28", //Wood
    waste: "#938373", //Waste
    geothermal: "#426B45", //Geothermal
    solar: "#F58020", //Solar
    wind: "#8DC179", //Wind
};

export default colorMap;


// WEBPACK FOOTER //
// ./src/colorMap.js